import React, { useState, useEffect } from "react";
import { useApiCategoryStock } from "../helpers/apiCategoryStock";

const IpServerInfo = () => {
   const [ipServerData, setIpServerData] = useState(null);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);
   
   const apiCategoryStock = useApiCategoryStock();

   useEffect(() => {
      const getIpServerData = async () => {
         try {
            setLoading(true);
            const response = await apiCategoryStock.GetIpServer();
            setIpServerData(response);
            setError(null);
         } catch (err) {
            setError(err.message || 'Có lỗi xảy ra khi tải dữ liệu IP Server');
            console.error('Error fetching IP Server data:', err);
         } finally {
            setLoading(false);
         }
      };

      getIpServerData();
   }, []);

   if (loading) {
      return (
         <div style={{ padding: '20px', textAlign: 'center' }}>
            <div>Đang tải dữ liệu IP Server...</div>
         </div>
      );
   }

   if (error) {
      return (
         <div style={{ padding: '20px', color: 'red' }}>
            <h3>Lỗi:</h3>
            <p>{error}</p>
         </div>
      );
   }
   

   return (
      <div style={{ padding: '20px' }}>
         <h2>Thông tin IP Server: {ipServerData?.data?.ip}</h2>
         
         <div style={{ 
            backgroundColor: '#f5f5f5', 
            padding: '15px', 
            borderRadius: '5px',
            fontFamily: 'monospace'
         }}>
            <h1>Thông tin IP Server: {ipServerData?.data?.ip}</h1>
         </div>
         
         {/* Refresh button */}
         <button 
            onClick={() => window.location.reload()} 
            style={{
               marginTop: '10px',
               padding: '8px 16px',
               backgroundColor: '#007bff',
               color: 'white',
               border: 'none',
               borderRadius: '4px',
               cursor: 'pointer'
            }}
         >
            Làm mới
         </button>
      </div>
   );
};

export default IpServerInfo;